var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../service/api.service';
import { TreeNode, TreeService } from '../tree/tree.service';
var AccessUnitService = /** @class */ (function (_super) {
    __extends(AccessUnitService, _super);
    function AccessUnitService(logger, api) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        return _this;
    }
    AccessUnitService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    AccessUnitService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService }
    ]; };
    return AccessUnitService;
}(TreeService));
export { AccessUnitService };
var NodeState = /** @class */ (function () {
    function NodeState() {
        this.opened = false;
        this.disabled = false;
        this.selected = false;
        this.checked = false;
    }
    return NodeState;
}());
export { NodeState };
var AccessUnitNode = /** @class */ (function (_super) {
    __extends(AccessUnitNode, _super);
    function AccessUnitNode(rec) {
        var _this = _super.call(this, rec) || this;
        _this.state = new NodeState();
        _this.li_attr = {};
        _this.a_attr = {};
        return _this;
    }
    return AccessUnitNode;
}(TreeNode));
export { AccessUnitNode };
var RoleSetting = /** @class */ (function () {
    function RoleSetting() {
        this.set_period = false;
        this.error = [];
    }
    return RoleSetting;
}());
export { RoleSetting };
var Role = /** @class */ (function () {
    function Role() {
        this.periods = [];
    }
    return Role;
}());
export { Role };
var Period = /** @class */ (function () {
    function Period() {
    }
    return Period;
}());
export { Period };
//# sourceMappingURL=accessunit.service.js.map